import { render } from "./LoanSubSuccessNot.vue?vue&type=template&id=8ce2451a"
import script from "./LoanSubSuccessNot.vue?vue&type=script&lang=js"
export * from "./LoanSubSuccessNot.vue?vue&type=script&lang=js"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__